module.exports = __webpack_public_path__ + "img/MMM.267e3d9e.png";